import { render, staticRenderFns } from "./SectionError.vue?vue&type=template&id=498c0e15&scoped=true&"
import script from "./SectionError.vue?vue&type=script&lang=ts&"
export * from "./SectionError.vue?vue&type=script&lang=ts&"
import style0 from "./SectionError.vue?vue&type=style&index=0&id=498c0e15&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c0e15",
  null
  
)

export default component.exports